import { i18n } from '@/commons/utils';


export const init = () => {
  const inputs = cube.$$('[name="loyaltySubscription"]');

  inputs.on('change', enableAgreement);
};


/**
 * Enable or disable the loyalty agreement checkbox according to the loyalty subscription choice.
 *
 */
function enableAgreement () {
  const checkbox = cube.$id('loyalty-agreement-checkbox');
  const container = checkbox.closest('.checkbox');
  const { classList } = checkbox.closest('.account-form__field');

  if (this.value === 'true') {
    checkbox.disabled = false;
    checkbox.removeAttribute('data-disabled');
    classList.remove('account-form__field--disabled');
  }
  else {
    checkbox.disabled = true;
    checkbox.setAttribute('data-disabled', '');
    classList.add('account-form__field--disabled');
    container.classList.remove('has-error');
  }
}


export const rules = {
  rules: {
    loyaltySubscription: {
      required: true
    },
  },

  messages: {
    'loyalty-agreement': {
      required: i18n('create_account.loyalty.required_terms_and_conditions')
    },
  }
};


// WEBPACK FOOTER //
// ./src/customer/create-account/create-account-loyalty-subscription.js